<script>
export default {
  name: 'OutputsViewer',
  template: '#outputs-viewer-template',
  props: {
    outputs: {
      Type: Object,
      required: true,
    },
  },
  setup(props) {
    return {};
  },
};
</script>
